import { PlanCoreBase } from "./plan.core.base"


export class PlanCore extends PlanCoreBase {

}